/* eslint-disable react/jsx-no-useless-fragment */
import React, { useContext, useEffect } from 'react';

import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import AppContext from '../../Context/AppContext';

import Perfil from './Perfil';
import MenuNavbar from './MenuNavbar';

function Header() {
  const { state } = useContext(AppContext);

  useEffect(() => {
  }, [state]);

  const renderNav = () => (
    <Navbar className="navbarMenu" bg="white" fixed="top">
      <Container>
        <MenuNavbar />
        <Perfil />
      </Container>
    </Navbar>
  );

  return (
    <>
      {
        (state.login) && renderNav()
      }
    </>
  );
}
export default Header;
